module.exports = __webpack_public_path__ + "static/media/foto9.43a2c5e0.png";